import { useState, useEffect } from 'react'
import { useAtom } from 'jotai'
import { omanRegionsAtom } from '../stores/oman.store'
import { fetchOmanRegions } from '../services/oman.api'

export const useRegionsByCountry = (countryCode: string) => {
    const [regions, setRegions] = useAtom(omanRegionsAtom)
    const [regionsLoading, setRegionsLoading] = useState(false)

    useEffect(() => {
        if (!countryCode) return
        setRegionsLoading(true)
        fetchOmanRegions(countryCode)
            .then(setRegions)
            .catch(() => setRegions([]))
            .finally(() => setRegionsLoading(false))
    }, [countryCode, setRegions])

    return { regions, regionsLoading }
}
